import { useQuery, useMutation, UseQueryOptions, UseQueryResult } from 'react-query'
import { QueryKeys } from './_query_keys'
// import { deleteBuildVersionData } from '../SampleData/buildVersionService'
import { useState } from 'react'
import { APIEndpoints } from '../constants/api-endpoints'
import { HttpRequest } from '../services/_http'

// Category API Hooks

export const useGetCategoryData = (searchOptions?: any, options?: UseQueryOptions): UseQueryResult<any> => {

    const method = 'GET'
    const queryKey = [QueryKeys.CATEGORIES, searchOptions]
    /** To keeping old data until response received with new data */
    const [keepPreviousData, setkeepPreviousData] = useState(true)
    return useQuery({
        queryKey,
        queryFn: () => HttpRequest({
            url: APIEndpoints.Categories,
            params: searchOptions,
            method
        }),
        refetchOnWindowFocus: false,
        keepPreviousData,
        onError: () => setkeepPreviousData(false),
        onSuccess: () => setkeepPreviousData(true),
        ...options
    })
}

export const useAddCategory = (options?: any) => {
    const method = 'POST'

    return useMutation(({ data }: { data: any }) => HttpRequest({
        url: `${APIEndpoints.Categories}`,
        method,
        data
    }), options)
}

export const useUpdateCategoriesData = (options?: any) => {
    const method = 'PUT'
    return useMutation(({ data, id }: { data: FormData, id: any }) => HttpRequest({
        url: `${APIEndpoints.Categories}/${id}`,
        method,
        data
    }), options)
}

export const useDeleteCategoriesData = (options?: any) => {
    const method = 'DELETE'
    return useMutation(({ id }: { id: any }) => HttpRequest({
        url: `${APIEndpoints.Categories}/${id}`,
        method,
    }), options)
}


export const useCategoryContent = (id: any, options?: UseQueryOptions): UseQueryResult<any> => {

    const method = 'GET'
    const queryKey = [QueryKeys.CATEGORY_CONTENT, id]
    return useQuery({
        queryKey,
        queryFn: () => HttpRequest({
            url: `${APIEndpoints.Categories}/${id}`,
            method
        }),
        enabled: !!id,
        refetchOnWindowFocus: false,
        ...options
    })
}

export const useUpdateCategoryStatus = (options?: any) => {
    const method = 'PATCH'
    return useMutation(({ data, id }: { data: any, id: any }) => HttpRequest({
        url: `${APIEndpoints.Categories}/${id}/status`,
        method,
        data
    }), options)
}


export const GetConfigData = (options?: UseQueryOptions): UseQueryResult<any, any> => {
    const method = 'GET'
    const queryKey = [QueryKeys.CATEGORY_CONFIG, 'options']

    /** To keeping old data until response received with new data */
    const [keepPreviousData, setkeepPreviousData] = useState(true)

    return useQuery({
        queryKey,
        queryFn: () => HttpRequest({
            url: `${APIEndpoints.Category}/config`,
            method
        }),
        refetchOnWindowFocus: false,
        keepPreviousData,
        onError: () => setkeepPreviousData(false),
        onSuccess: () => setkeepPreviousData(true),
        ...options
    })
}

export const useGetItemsParent = (options?: any) => {
    const method = 'POST'

    return useMutation(({ parentId, type, data }: { parentId: string, type: string, data?: any }) => HttpRequest({
        url: `${APIEndpoints.Categories}/parent/${parentId}/${type}`,
        method,
        data
    }), options)
}

export const fetchCategorySearchApi = async (search: string) => {
    const { data } = await HttpRequest({
        url: `${APIEndpoints.Categories}/search/all?search=${encodeURIComponent(search)}`,
        method: 'GET'
    });
    return data.results;
};

export const useCategorySearch = (searchTerm: string) => {
    return useQuery({
        queryKey: ["category-search", searchTerm],
        enabled: Boolean(searchTerm.trim()),
        keepPreviousData: true,
        staleTime: 30 * 1000,
        queryFn: async () => {
            const { data } = await HttpRequest({
                url: `${APIEndpoints.Categories}/search/all?search=${encodeURIComponent(searchTerm)}`,
                method: "GET"
            })
            return data
        }
    })
};

export const useCategorySearchContent = (searchTerm: string) => {
     return useQuery({
        queryKey: ["category-search", searchTerm],
        enabled: Boolean(searchTerm.trim()),
        keepPreviousData: true,
        staleTime: 30 * 1000,
        queryFn: async () => {
            const { data } = await HttpRequest({
                url: `${APIEndpoints.Categories}/search/content?search=${encodeURIComponent(searchTerm)}`,
                method: "GET"
            })
            return data
        }
    })
}